import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";

type Props = {
  onSuccess?: () => void;
  onError?: (error: any, params: Params) => void;
};

type Params = {
  cmaId: string;
  imgId: number;
};

export const useMakeSubjectPropertyCoverPhoto = (props?: Props) => {
  const { onSuccess, onError } = props || {};
  const api = getCMAApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, imgId } = params;

      const response = await api.cMAControllerSelectCoverImage({
        id: cmaId,
        selectCMACoverImageDto: { properyImageId: imgId },
      });

      return response;
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: async (error, params) => {
      console.error(
        `Failed to make CMA (${params.cmaId}) cover photo with id ${params.imgId}`,
        error,
      );
      onError?.(error, params);
    },
    onSettled: (_, __, { cmaId }) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
        });
      }, 1000);
    },
  });

  return mutation;
};
